import { Pipe, PipeTransform } from '@angular/core';
import { E_FR_LOC } from '@shared/constants/enums.const';
import { HelperService } from '../../services/helper.service';

@Pipe({
  name: 'relativeLinks',
  standalone: true,
})
export class RelativeLinksPipe implements PipeTransform {

  constructor(
    private HELPER: HelperService,
  ) {}

  transform(url: string): string {
    if (!url) return url;

    const indexFrLoc = 0;
    const frLocArray: string[] = Object.values(E_FR_LOC);
    const regex = /href="((?!(https?|www))[^"]*)"/g;

    return url.replace(regex, (match: string, url: string) => {
      if (url.includes('mailto:') || url.includes('tel:')) return `href="${url}"`;

      const urlArray = url.split('/');
      if (!frLocArray.includes(urlArray[indexFrLoc])) {
        urlArray.unshift(this.HELPER.frLoc);
      }
      return `href="${urlArray.join('/')}"`;
    });

  }


}
